import axios from "axios";
import "../config";

export default {
  async find({folderAbove}) {
    //   id - opt
    //   folder - opt
    return axios.get(`/folders?folder=${folderAbove}`);
  },
  async create(data) {
    //   name - req
    //   folderAbove
    return axios.post(`/folders`, data);
  },
  async delete(id) {
    //   id - req
    return axios.delete(`/folders/${id}`);
  },
  async move(data) {
    return axios.put(`/folders/move`, data);
  },
  async names(data) {
    return axios.post(`/folders/names`, data);
  },
};
